import { IState } from 'shared/store';

export const selectOfferPromoDescription = (state: IState): string =>
  state.offerData.offer.promotion?.promotionDescription || '';
